import {ConsoleLogger} from "./ConsoleLogger";
import {GenericConfig} from "../GenericConfig";

export class Logger {

	/**
	 * Does not apply any formatting on it's own.
	 * See class {@link LogMessageFormatter}.
	 */
	public static debug(source: String, msg: string) {
        if(GenericConfig.IsConsoleLoggerEnabled())
		    ConsoleLogger.debug(source, msg);
	}

	/**
	 * Does not apply any formatting on it's own.
	 * See class {@link LogMessageFormatter}.
	 */
	public static info(source: String, msg: string) {
        if(GenericConfig.IsConsoleLoggerEnabled())
		    ConsoleLogger.info(source, msg);
	}

	/**
	 * Does not apply any formatting on it's own.
	 * See class {@link LogMessageFormatter}.
        */
    public static warn(source: String, msg: string) {
        if(GenericConfig.IsConsoleLoggerEnabled())
            ConsoleLogger.warn(source, msg);
	}

	/**
	 * Does not apply any formatting on it's own.
	 * See class {@link LogMessageFormatter}.
	 */
	public static error(source: String, msg: string) {
        if(GenericConfig.IsConsoleLoggerEnabled())
		    ConsoleLogger.error(source, msg);
	}
}